module.exports = __webpack_public_path__ + "static/media/backg_casas.0c1360d4.svg";